<template>
  <div class="modal modal-filter-details fade" id="modal-change-log" role="dialog" aria-labelledby="location-label" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="location-label">Booking Change Log</h4>
        </div>
        <div class="modal-body">
          <ul class="change-log">
            <booking-history-modal-item
              v-for="item in history"
              :key="item.id"
              :item="item"/>
          </ul>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-dismiss="modal"><i class="fa fa-close"></i> Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import BookingHistoryModalItem from './BookingHistoryModalItem'
import $ from 'jquery'

export default {
  props: {
    booking: {
      required: true,
      type: Object
    }
  },

  components: {
    BookingHistoryModalItem
  },

  mounted () {
    $(this.$el).on('show.bs.modal', this.handleGetBookingHistoryCallback)
  },

  computed: mapState('booking', ['history']),

  methods: {
    ...mapActions('booking', ['getHistory']),

    handleGetBookingHistoryCallback () {
      return this.getHistory({ id: this.booking.id })
    }
  }
}
</script>
